import { isNaN, toNumber } from 'lodash'

const isDbId = id => !isNaN(toNumber(id))

export default isDbId
